const commonConfigs = {
    authCookieName: 'authorized'
};

const configs = {
    dev: {
        backendUrl: 'http://localhost:3000/api',
        baseName: '/',
        loginPagePath: '/kirjaudu-sisaan',
        logoLink: 'https://tietopalvelut-test.tietopalvelut.biz'
    },
    test: {
        backendUrl: '/analysaattori/api',
        baseName: '/analysaattori',
        loginPagePath: '/analysaattori/kirjaudu-sisaan',
        logoLink: 'https://tietopalvelut-test.tietopalvelut.biz'
    },
    prod: {
        backendUrl: '/analysaattori/api',
        baseName: '/analysaattori',
        loginPagePath: '/analysaattori/kirjaudu-sisaan',
        logoLink: 'https://tietopalvelut.almatalent.fi'
    }
};

const buildEnvironment = process.env.REACT_APP_BUILD_ENV || 'dev';
const config = { ...commonConfigs, ...configs[buildEnvironment] };
export default config;
